import { SALESFORCE_FALLBACK_SALES_REP_CALENDAR_URL } from "@faire/web-api/indigofair/settings/SALESFORCE_FALLBACK_SALES_REP_CALENDAR_URL";

import { getSettingValueWithoutAssignment } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingSalesforceFallbackSalesRepCalendarUrl = (): string =>
  getSettingValueWithoutAssignment(
    SALESFORCE_FALLBACK_SALES_REP_CALENDAR_URL,
    "https://calendly.com/madeleine-maxwell_15_mins"
  );
